import React from 'react';

export const SelectVenueSkeleton = () => {
  return (
    <div className='max-w-[1064px] mx-auto '>
      <div className='animate-pulse flex flex-row items-center gap-6 pt-3 pb-4 md:pb-6 md:mb-10 mb-4 px-4'>
        <div className='w-[80px] h-[80px] md:w-[100px] md:h-[100px] rounded-full bg-gray-300'></div>
        <div className='flex flex-col gap-1'>
          <div className='h-6 w-48 bg-gray-300 rounded-sm'></div>
          <div className='h-4 w-36 bg-gray-200 rounded-sm mt-1'></div>
        </div>
      </div>
    </div>
  );
};
